import moment from 'moment';

export function sortByString (a, b){  
  if (a == null || b == null) {
    if (a != null) { // if A is null, then B must not be. A should be higher
      return -1;
    }
    if (b != null) { // if B is null, then A must not be. B should be higher
      return 1;
    }
    // neither is null, so they're equal.
    return 0
  }

    const nameA = a.toUpperCase(); // ignore upper and lowercase
    const nameB = b.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
  
    // names must be equal
    return 0;
  };

export function sortByDate(a, b) {
    const nameA = moment(a).unix(); // ignore upper and lowercase
    const nameB = moment(b).unix(); // ignore upper and lowercase
       
    if (isNaN(nameA) || isNaN (nameB)) {
      if (!isNaN(nameA)) { // if A is a number, then B must not be. A should be higher
        return -1;
      }
      if (!isNaN(nameB)) { // if B is a number, then A must not be. B should be higher
        return 1;
      }
      // neither is a number, so they're equal.
      return 0
    }

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
  
    // names must be equal
    return 0;
}